/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */

import { SagaIterator } from 'redux-saga';
/**
 *
 * @author Mikhail Kokoulin
 * @author Aleksandr Perkhunov
 * @version 1.10.0
 * @since 1.0.1
 */
import { select } from 'redux-saga/effects';

import { makeSelectorTableButtons } from '../../../../components/Table/selectors/tableSelectors';
import { ITableButtonTypes } from '../../../../components/Table/types/tableFooterButtonsTypes';
import { AccessComponentKeyEnum } from '../../constants/guard/guardConstants';
import { FooterButtonKeys } from '../../types/conditionTypes';

export function* isButtonConditionsSaga(componentKey: AccessComponentKeyEnum): SagaIterator {
    if (FooterButtonKeys.includes(componentKey)) {
        const buttons = yield select(makeSelectorTableButtons());
        return buttons.some((b: ITableButtonTypes) => {
            return b.buttonName === componentKey
        });
    }

    return true;
}
